/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Slider
 */

import Carousel from 'react-bootstrap/Carousel'
import { isMobile } from "react-device-detect";

// Components
import ImgNextGen from '../../../components/ImgNextGen';

// Styles
import './style.scss';

const Slider = (props) => {
    const items = props.items;

    return (
        <div id="slider">
            <Carousel
                controls={!isMobile}
            >
                {items.map((item, idx) => {
                    return (
                        <Carousel.Item key={idx}>
                            <div className="content-overlay"></div>
                            
                            <ImgNextGen
                                srcWebp320={item.srcWebp320}
                                srcWebp480={item.srcWebp480}
                                srcWebp640={item.srcWebp640}
                                srcWebp800={item.srcWebp800}
                                srcWebp={item.srcWebp}
                                fallback320={item.src320}
                                fallback480={item.src480}
                                fallback640={item.src640}
                                fallback800={item.src800}
                                fallback={item.src}
                                alt={item.altText}
                            />

                            <Carousel.Caption>
                                <h1>{item.header}</h1>
                                <p>{item.caption}</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    );
                })}
            </Carousel>
        </div>
    );
}
export default Slider;